import React from 'react';
import { connect } from 'react-redux';

const EpixBoxesTableRow = ({ box, companies, selectedCompany, deleteMode }) => {
  const onClick = async e => {
    try {
      if (deleteMode) {
        const filter = {
          name: 'company',
          value: box?.Company[0]?.name,
          suggestion: { ...box?.Company[0] },
        };
        selectedCompany(filter);
      } else {
        const companyID = e.currentTarget.id;
        const suggestion = companies.docs.find(item => {
          return item._id === companyID;
        });
        const filter = {
          name: 'company',
          value: suggestion.name,
          suggestion: { ...suggestion },
        };
        selectedCompany(filter);
      }
    } catch (error) {}
  };
  const onKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick(e);
    }
  };

  const companyName = box?.Company?.[0]?.name ?? 'Company';
  const companyId = box?.Company?.[0]?._id;

  const ariaLabel = `Select Company ${companyName}. Total Edge Devices ${box?.total ?? 0}, Registered ${box?.online ?? 0}, Unregistered ${box?.offline ?? 0}, Unmonitored ${box?.unmonitored ?? 0}`;

  return (
    <tr
      id={companyId}
      onClick={onClick}
      onKeyDown={onKeyDown}
      className="row-hover"
      tabIndex={0}
      aria-label={ariaLabel}
    >
      <td scope="row">{companyName}</td>
      <td>{box?.total}</td>
      <td>{box?.online}</td>
      <td>{box?.offline}</td>
      <td>{box?.unmonitored}</td>
      {/*<td>{box?.alarmed}</td>*/}
    </tr>
  );
};

const mapStateToProps = state => ({
  companies: state.AppState.companies,
});

export default connect(
  mapStateToProps,
  null,
)(EpixBoxesTableRow);
